import React, { useContext, useEffect, useState } from "react";

import { getLocalFranchiseStore, getStoreLocalData, getUserData } from "../../../utils/localStorage";
import { useNavigate } from "react-router-dom";
import TabMenu from "../../TabMenu";
import AdminMenu from "../../AdminMenu";
import {
  getStoreRiderInfo,
  getStoreTimeSlot,
} from "../../../services/StoreRiderInfo/StoreRiderInfo";
import { getBrandStore } from "../../../services/StoreUsers/PostStoreUsers";
import { postUserRiderPickupRequest } from "../../../services/RiderDashboard/postUserRiderPickupRequest";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import { customerSearch } from "../../../services/SearchAPI/SearchCustomer";
import SupportAdminMenu from "../../SupportAdminMenu";

const DashboardPickupRequest = () => {
  const navigate = useNavigate();
  const [adminPickupRequestModalVisible, setAdminPickupRequestModalVisible] =
    useState(false);

  const { brandProfileData, userProfileRole } = getUserData();
  const { storeLocalData } = getStoreLocalData();
  const countryCode = storeLocalData?.countryCode;


   const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  useEffect(() => {
    setAdminPickupRequestModalVisible(true);
  }, []);

  const [visible, setVisible] = useState(false);
  const [storeId, setStoreId] = useState(null);
  const [mobileNumberValue, setMobileNumberValue] = useState("");
  const [remarkValue, setRemarkValue] = useState("");
  const [error, setError] = useState("");
  const [remarkError, setRemarkError] = useState("");

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  let initialDate = new Date();
  const [date, setDate] = useState(new Date(initialDate));
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [time, setTime] = useState(new Date());
  const [showTimePicker, setShowTimePicker] = useState(false);

  const [timeSlotData, setTimeSlotData] = useState([]);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState([]);
  const [timeSlotError, setTimeSlotError] = useState("");
  const [assignStoreError, setAssignStoreError] = useState("");
  const [assignRiderError, setAssignRiderError] = useState("");
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [assignStoreValue, setAssignStoreValue] = useState("");
  const [assignRiderValue, setAssignRiderValue] = useState("");
  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3); // Add 3 months to current date
  const [customerNameValue, setCustomerNameValue] = useState("");
  const [addressValue, setAddressValue] = useState("");

  const [storeUserData, setStoreUserData] = useState([]);
  const [riderInfo, setRiderInfo] = useState([]);

  const handleSearch = async (number) => {

    let isValidPartial = false;
    let isValidFull = false;
    let requiredLength = 10;

    // Validation based on country code
    if (countryCode === "+91") {
      // India: starts with 5-9 and max 10 digits
      isValidPartial = /^[5-9]\d{0,9}$/.test(number) || number === "";
      isValidFull = /^[5-9]\d{9}$/.test(number);
      requiredLength = 10;

    } else if (countryCode === "+971") {
      // UAE: starts with 5 and max 9 digits
      isValidPartial = /^5\d{0,8}$/.test(number) || number === "";
      isValidFull = /^5\d{8}$/.test(number);
      requiredLength = 9;
    }

    if (isValidPartial) {

      if (number.length === requiredLength) {
        setError("");
      } else {
        setCustomerNameValue("");
        setAddressValue("");

        setError(
          `Please enter a ${requiredLength}-digit mobile number`
        );
      }

      setMobileNumberValue(number);

      if (isValidFull) {

        const newData = {
          storeId: storeId,
          searchText: number,
          searchBy: "mobile",
          maxLimit: 50,
        };

        try {
          const response = await customerSearch(
            storeId,
            newData
          );

          if (!response.data.error) {

            const Res = response.data;

            const brandCustomerFirstNames = Res.map(
              (item) => ({
                id: item.id,
                firstName:
                  item.brandCustomer.firstName,
                lastName:
                  item.brandCustomer.lastName
                    ? item.brandCustomer.lastName
                    : "",
                email: item.brandCustomer.email,
                mobile: item.brandCustomer.mobile,
                customerId:
                  item.brandCustomer.customerId,
                ...item,
              })
            );

            if (brandCustomerFirstNames.length > 0) {

              setCustomerNameValue(
                brandCustomerFirstNames[0]
                  .firstName +
                " " +
                brandCustomerFirstNames[0]
                  .lastName
              );

              setAddressValue(
                brandCustomerFirstNames[0]
                  .address.address
              );
            }
          }
        } catch (error) {
          console.error("Error:", error);
        }

      } else {
        setError("Please enter a valid mobile number");
      }
    }
  };

  // const handleSearch = async (number) => {
  //   if (/^[56789]\d{0,9}$/.test(number) || number === "") {
  //     if (number.length === 10) {
  //       setError(""); // Clear error if the input is valid
  //     } else {
  //       setCustomerNameValue("")
  //       setAddressValue("")
  //       setError("Please enter a 10-digit mobile number");
  //     }
  //     setMobileNumberValue(number);
  //     if (number.length === 10) {
  //       const newData = {
  //         storeId: storeId,
  //         searchText: number,
  //         searchBy: "mobile",
  //         maxLimit: 50,
  //       };
  //       try {
  //         const response = await customerSearch(storeId, newData);
  //         if (!response.data.error) {
  //           const Res = response.data;
  //           const brandCustomerFirstNames = Res.map((item) => ({
  //             id: item.id,
  //             firstName: item.brandCustomer.firstName,
  //             lastName: item.brandCustomer.lastName
  //               ? item.brandCustomer.lastName
  //               : "",
  //             email: item.brandCustomer.email,
  //             mobile: item.brandCustomer.mobile,
  //             customerId: item.brandCustomer.customerId,
  //             ...item,
  //           }));

  //           // if (searchType === 'mobile') {
  //           //     if (/^\d{10}$/.test(text) && brandCustomerFirstNames.length === 0) {
  //           //         // Set the valid mobile number and show the modal
  //           //         setValidMobileNumber(text);
  //           //         setAddNewCustomerModalVisible(true);
  //           //     }
  //           // }
            
  //           // setCustomerSearchData(brandCustomerFirstNames[0])
  //           setCustomerNameValue(brandCustomerFirstNames[0].firstName + " " + brandCustomerFirstNames[0].lastName)
  //           setAddressValue(brandCustomerFirstNames[0].address.address)

  //           // setFilteredData(brandCustomerFirstNames);
  //           // setSearchTerm(text);
  //         }
  //       } catch (error) {
  //         console.error("Error:", error);
  //       }
  //     } else {
  //       setError("Please enter a valid mobile number");
  //     }
  //   }
  // };

  const fetchStoreRiderTimeSlot = (storeId, currentTime) => {
    getStoreTimeSlot(storeId, currentTime)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setTimeSlotData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchStoreUser = () => {
    getBrandStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const newRes = Res.map((item) => ({
            name: item.storeName,
            value: item.id,
          }));
          setStoreUserData(newRes);
          fetchStoreRiderInfo(Res[0].id);
          setStoreId(Res[0].id);
          const currentTime = date;
          currentTime.setHours(
            currentTime.getHours(),
            currentTime.getMinutes() + 1
          );
          fetchStoreRiderTimeSlot(Res[0].id, currentTime.getHours());
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchStoreRiderInfo = (storeId) => {
    getStoreRiderInfo(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const newRes = Res.map((item) => ({
            name: item.fullName,
            value: item.id,
          }));
          setRiderInfo(newRes);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  // useFocusEffect(
  //   useCallback(() => {
  //     if (mobileNumber !== undefined) setMobileNumberValue(mobileNumber);
  //     navigation.setParams({mobileNumber: undefined});
  //   }, [mobileNumber]),
  // );

  const fetchFranchiseStore = async () => {
            const franchiseStore = await getLocalFranchiseStore();
            if (franchiseStore.franchiseStore !== null) {
              const Res = franchiseStore.franchiseStore.filter((item) => item.status === "ACTIVE");
              const newRes = Res.map((item) => ({
                name: item.storeName,
                value: item.id,
              }));
              setStoreUserData(newRes);
              fetchStoreRiderInfo(Res[0].id);
              setStoreId(Res[0].id);
              const currentTime = date;
              currentTime.setHours(
                currentTime.getHours(),
                currentTime.getMinutes() + 1
              );
              fetchStoreRiderTimeSlot(Res[0].id, currentTime.getHours());
            } else {
              setStoreUserData([]);
            }
          };
    

  useEffect(() => {
    if (userRole === "BY_FRANCHISE_ADMIN") {
      fetchFranchiseStore();
     } else {
       fetchStoreUser();
      }
  }, [adminPickupRequestModalVisible]);

  const handleAssignRiderChange = (selectedItem) => {
    setAssignRiderValue(selectedItem);
  };
  const handleAssignStoreChange = (selectedItem) => {
    setAssignStoreValue(selectedItem);
    fetchStoreRiderInfo(selectedItem);
    setStoreId(selectedItem);
    setAssignRiderValue("");
    setMobileNumberValue("");
  };

  const handleDateChange = (selectedDate) => {
    if (selectedDate !== undefined) {
      
        const utcDate = new Date(
          Date.UTC(
            selectedDate.getFullYear(),
            selectedDate.getMonth(),
            selectedDate.getDate()
          )
        );
        setDate(utcDate);
        if (utcDate >= new Date()) {
          fetchStoreRiderTimeSlot(storeId, utcDate.getHours());
        } else {
          setSelectedTimeSlot([]);
        }
    }
  };

  // const handleDateChange = (event, selectedDate) => {
  //   if (selectedDate !== undefined) {
  //     // Prevent selection of past dates
  //     if (selectedDate >= new Date()) {
  //       setDate(selectedDate);
  //     }
  //   }
  //   setShowDatePicker(false);
  // };

  const handleTimeChange = (event, selectedTime) => {
    // if (selectedTime !== undefined) {
    // Prevent selection of past times
    const currentTime = date;
    currentTime.setHours(
      selectedTime.getHours(),
      selectedTime.getMinutes() + 1
    );
    if (currentTime >= new Date()) {
      setTime(currentTime);
      fetchStoreRiderTimeSlot(storeId, currentTime.getHours());
      setTimeSlotError("");
    } else {
      setTime(new Date());
      setSelectedTimeSlot([]);
      setTimeSlotError("Please Chose Correct Pickup Day And Time");
    }
    // }
    setShowTimePicker(false);
  };

  const handleConfirmPickup = () => {
    if (assignStoreValue === "") {
      setAssignStoreError("Please Chose Any Store");
    } else if (assignRiderValue === "") {
      setAssignStoreError("");
      setAssignRiderError("Please Chose Any Rider");
    } else if (mobileNumberValue === "") {
      setAssignStoreError("");
      setAssignRiderError("");
      setError("Please enter a 10-digit mobile number");
    } else if (selectedTimeSlot.length <= 0) {
      setTimeSlotError("Please Chose Correct Pickup Date And Time");
    } else if (remarkValue === "") {
      setRemarkError("Please enter a remark");
    } else {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        // Logic for creating a new pickup request
        const data = {
          customerMobile: mobileNumberValue,
          storeUserId: assignRiderValue,
          storeId: storeId,
          pickupOn: date,
          pickupTimeSlot: selectedTimeSlot,
          remarks: remarkValue,
          customerName: customerNameValue ? customerNameValue : "BUYER",
          address : {
            addressLine1: addressValue ? addressValue : "Line 1" ,
            addressLine2: "",
            city: "",
            landmark: "",
            pin: "",
            state: ""
          }
        };

        // Call the service function for creating pickup request
        postUserRiderPickupRequest(storeId, assignRiderValue, data)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              if (Res) {
                const message = Res.message;
                const status = Res.status;
                // sendResponse({message, status, modalFun: false});
                // Reset state variables
                if (status === true) {
                  setModalVisible(true);
                  setModalStatus("success");
                  setModalText(message);
                  setTimeout(async () => {
                    navigate("/");
                  }, 2000); // Replace with actual async operation duration
                } else {
                  setModalVisible(true);
                  setModalStatus("not Success");
                  setModalText(message);
                  setTimeout(async () => {
                    navigate("/");
                  }, 2000); // Replace with actual async operation duration
                }
                setDate(new Date(initialDate));
                setTime(new Date());
                setSelectedTimeSlot([]);
                setMobileNumberValue("");
                setRemarkValue("");
                setTimeSlotError("");
                setAssignStoreError("");
                setAssignRiderError("");
                setAssignStoreValue("");
                setAssignRiderValue("");
                setRemarkError("");
                setIsSubmitButtonPressed(false);
                //  navigation.navigate('Home');
              }
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    }
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate(-1)}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold ">Pickup Request</p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "30px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        <div className="flex flex-row">
          <div className="mt-4 mx-4 flex-1">
            <FloatLabel>
              <Dropdown
                id="assignStoreValue"
                value={assignStoreValue}
                onChange={(e) => handleAssignStoreChange(e.target.value)}
                options={storeUserData}
                optionLabel="name"
                placeholder="Store"
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              {assignStoreError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {assignStoreError}
                </p>
              )}
              <label
                htmlFor="assignStoreValue"
                className="text-md"
                style={{ color: "blue" }}
              >
                Store <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
          <div className="mt-4 mx-4 flex-1">
            <FloatLabel>
              <Dropdown
                id="assignRiderValue"
                value={assignRiderValue}
                onChange={(e) => handleAssignRiderChange(e.target.value)}
                options={riderInfo}
                optionLabel="name"
                placeholder="Assign Rider"
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              {assignRiderError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {assignRiderError}
                </p>
              )}
              <label
                htmlFor="assignRiderValue"
                className="text-md"
                style={{ color: "blue" }}
              >
                Assign Rider <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
        </div>
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="mobileNumberValue"
              value={mobileNumberValue}
              onChange={(e) => {
                // handleMobileNumberChange(e.target.value);
                handleSearch(e.target.value);
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              keyfilter="int"
              maxLength={countryCode === "+971" ? 9 : 10}
            />
            {error && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {error}
              </p>
            )}

            <label
              htmlFor="mobileNumberValue"
              className="text-md"
              style={{ color: "blue" }}
            >
              Mobile Number <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
        <div className="flex flex-row">
          <div className="mx-4 mt-4 flex-1">
            <FloatLabel>
              <InputText
                id="customerName"
                value={customerNameValue}
                onChange={(e) => {
                  setCustomerNameValue(e.target.value);
                }}
                className="w-full text-xl p-2 border-round-xl shadow-2"
                style={{
                  backgroundColor: "#fff",
                }}
              />

              <label
                htmlFor="customerName"
                className="text-md"
                style={{ color: "blue" }}
              >
                Customer Name
              </label>
            </FloatLabel>
          </div>
          <div className="mx-4 mt-4 flex-1">
            <FloatLabel>
              <InputText
                id="address"
                value={addressValue}
                onChange={(e) => {
                  setAddressValue(e.target.value);
                }}
                className="w-full text-xl p-2 border-round-xl shadow-2"
                style={{
                  backgroundColor: "#fff",
                }}
              />

              <label
                htmlFor="address"
                className="text-md"
                style={{ color: "blue" }}
              >
                Address
              </label>
            </FloatLabel>
          </div>
        </div>
        <div className="mx-4 mt-5 flex-1">
          <FloatLabel>
            <Calendar
              id="pickupDate"
              value={date}
              onChange={(e) => handleDateChange(e.value)}
              showIcon
              minDate={new Date()}
              maxDate={maximumDate}
              className="w-full  bg-white-alpha-20 border-round-lg p-1 text-md text-primary-50"
              dateFormat="dd/mm/yy"
            />
            <label
              htmlFor="pickupDate"
              className="text-md"
              style={{ color: "blue" }}
            >
              Pickup Date <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <Dropdown
              id="selectSlot"
              value={selectedTimeSlot}
              onChange={(e) => setSelectedTimeSlot(e.target.value)}
              options={timeSlotData}
              placeholder="Select Pickup Time"
              optionLabel="name"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />
            <label
              htmlFor="selectSlot"
              className="text-md"
              style={{ color: "blue" }}
            >
              Select Time Slot <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
        {timeSlotError && (
          <div className="inline-flex flex-column gap-2 mx-4">
            <p className="font-normal text-lg block" style={{ color: "red" }}>
              {timeSlotError}
            </p>
          </div>
        )}
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="remarkValue"
              value={remarkValue}
              onChange={(e) => {
                setRemarkValue(e.target.value);
                setRemarkError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {remarkError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {remarkError}
              </p>
            )}

            <label
              htmlFor="remarkValue"
              className="text-md"
              style={{ color: "blue" }}
            >
              Remark <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex mt-4 ">
        <Button
          disabled={isSubmitButtonPressed}
          onClick={handleConfirmPickup}
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
        >
          <p className=" w-full text-xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <TabMenu />

      {userRole === "BY_SUPPORT_ADMIN"
        ? <SupportAdminMenu setVisible={setVisible} visible={visible} /> :
        <AdminMenu setVisible={setVisible} visible={visible} />
      } 
      
      
    </div>
  );
};

export default DashboardPickupRequest;
